const merge = require('webpack-merge')
const prodEnv = require('./prod.env')
const localEnv = require('./local.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_URL: '"development_api_url"',
  SITE_URL: '"development_site_url"',
}, localEnv)



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 650
// module chunks = 1